import { createSlice } from '@reduxjs/toolkit';

import { CLASS_TAG_TYPES } from '@classCreation/data/classTagTypes';
import { ACADEMY_PROJECT_MODAL_STAGES } from '@classCreation/data/academyProjectModalStages';

const initialState = {
  classType: '',
  academyProjectModalStage: ACADEMY_PROJECT_MODAL_STAGES.notOpen,
  academyTopicInput: null,
  preLectureContent: null,
  postLectureContent: null,
  literatureResource: null,
  courseGroup: null,
  contestType: null,
  liveLecture: null,
  classTag: CLASS_TAG_TYPES[0],
  preRead: null,
  assignment: null,
  homework: null,
  contest: null,
  academyProject: null,
};

export const createClassForm = createSlice({
  name: 'createClassForm',
  initialState,
  reducers: {
    setClassType: (state, action) => {
      state.classType = action.payload;
    },
    setAcademyProjectModalStage: (state, action) => {
      state.academyProjectModalStage = action.payload;
    },
    setAcademyTopicInput: (state, action) => {
      state.academyTopicInput = action.payload;
    },
    setPreLectureContent: (state, action) => {
      state.preLectureContent = action.payload;
    },
    setPostLectureContent: (state, action) => {
      state.postLectureContent = action.payload;
    },
    setLiteratureResource: (state, action) => {
      state.literatureResource = action.payload;
    },
    setCourseGroup: (state, action) => {
      state.courseGroup = action.payload;
    },
    setContestType: (state, action) => {
      state.contestType = action.payload;
    },
    setLiveLecture: (state, action) => {
      state.liveLecture = action.payload;
    },
    setClassTag: (state, action) => {
      state.classTag = action.payload;
    },
    setPreRead: (state, action) => {
      state.preRead = action.payload;
    },
    setAssignment: (state, action) => {
      state.assignment = action.payload;
    },
    setHomework: (state, action) => {
      state.homework = action.payload;
    },
    setContest: (state, action) => {
      state.contest = action.payload;
    },
    setAcademyProject: (state, action) => {
      state.academyProject = action.payload;
    },
    removeLiveLecture: (state) => {
      state.preLectureContent = null;
      state.postLectureContent = null;
      state.literatureResource = null;
      state.liveLecture = null;
    },
    resetCreateClassForm: (state) => {
      for (const key in initialState) {
        state[key] = initialState[key];
      }
    },
  },
});

export const {
  setAcademyTopicInput,
  setClassType,
  setAcademyProjectModalStage,
  setCourseGroup,
  setContestType,
  removeLiveLecture,
  setPreLectureContent,
  setPostLectureContent,
  setLiteratureResource,
  setLiveLecture,
  setClassTag,
  setPreRead,
  setAssignment,
  setHomework,
  setContest,
  setAcademyProject,
  resetCreateClassForm,
} = createClassForm.actions;
export default createClassForm.reducer;
